import React from 'react';
import isFunction from 'lodash/isFunction';
import isString from 'lodash/isString';
import get from 'lodash/get';
import { isValidElementType } from 'react-is';
import { isCorrectSpec } from '../../helpers';
import { Controller } from './Controller';
import { useCreateContext, useCreateSearchContext, useDynamicFieldMirror, useIntegrationFF, useMutators, useSearchStore, useStore, } from './hooks';
import { getDefaultSearchFunction, isCorrectConfig } from './utils';
export const DynamicField = ({ name, spec, config, Monaco, generateRandomValue, search, withoutInsertFFDebounce, mutators: externalMutators, __mirror, }) => {
    const DynamicFormsCtx = useCreateContext();
    const SearchContext = useCreateSearchContext();
    const { tools, store } = useStore(name);
    const watcher = useIntegrationFF(store, withoutInsertFFDebounce);
    const { mutatorsStore, mutateDFState } = useMutators(externalMutators);
    const { store: searchStore, setField, removeField, isHiddenField } = useSearchStore();
    const context = React.useMemo(() => ({
        config,
        Monaco: isValidElementType(Monaco) ? Monaco : undefined,
        generateRandomValue,
        tools: Object.assign(Object.assign({}, tools), { mutateDFState }),
        store,
        mutatorsStore,
        __mirror,
    }), [tools, config, Monaco, __mirror, generateRandomValue, mutatorsStore, mutateDFState, store]);
    const searchContext = React.useMemo(() => ({
        setField,
        removeField,
        isHiddenField,
        searchFunction: isFunction(search) ? search : getDefaultSearchFunction(search),
    }), [isHiddenField, removeField, search, setField]);
    const correctParams = React.useMemo(() => isString(name) && isCorrectSpec(spec) && isCorrectConfig(config), [name, spec, config]);
    useDynamicFieldMirror({
        useStore: { tools, store },
        useIntegrationFF: watcher,
        useSearchStore: { store: searchStore, setField, removeField, isHiddenField },
    }, __mirror);
    if (correctParams) {
        return (React.createElement(DynamicFormsCtx.Provider, { value: context },
            React.createElement(SearchContext.Provider, { value: searchContext },
                React.createElement(Controller, { spec: spec, name: name, parentOnChange: null, parentOnUnmount: null, value: get(store.values, name) }),
                watcher)));
    }
    return null;
};
